export abstract class JsonHelper {
    static processRevisioneJson = (toProcess: object): object => {
        let json = JsonHelper.flattenJson(toProcess);
        for (const [key, value] of Object.entries(json)) {
            if (key.includes('my:') || key.includes('-')) {
                let newKey = key.replace(/my:/g, 'my_');
                newKey = newKey.replace(/-/g, '__');
                JsonHelper.renameKey(json, key, newKey);
            }
        }
        json = JsonHelper.unflatten(json);
        return json;
    };

    static restoreRevisioneJson = (toProcess: object): object => {
        let json = JsonHelper.flattenJson(toProcess);
        for (const [key, value] of Object.entries(json)) {
            if (key.includes('my_') || key.includes('__')) {
                let newKey = key.replace(/my_/g, 'my:');
                newKey = newKey.replace(/__/g, '-');
                JsonHelper.renameKey(json, key, newKey);
            }
        }
        json = JsonHelper.unflatten(json);
        return json;
    };

    private static renameKey = (obj, oldKey, newKey) => {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
    };

    static flattenJson = (data) => {
        const result = {};
        const recurse = (cur, prop) => {
            if (Object(cur) !== cur) {
                result[prop] = cur;
            } else if (Array.isArray(cur)) {
                const l = cur.length;
                for (let i = 0; i < l; i++) {
                    recurse(cur[i], prop + '[' + i + ']');
                }
                if (l === 0) {
                    result[prop] = [];
                }
            } else {
                let isEmpty = true;
                // tslint:disable-next-line:forin
                for (const p in cur) {
                    isEmpty = false;
                    recurse(cur[p], prop ? prop + '.' + p : p);
                }
                if (isEmpty && prop) {
                    result[prop] = {};
                }
            }
        };
        recurse(data, '');
        return result;
    };

    static unflatten = (data) => {
        if (Object(data) !== data || Array.isArray(data)) {
            return data;
        }
        const regex = /\.?([^.\[\]]+)|\[(\d+)\]/g;
        const resultholder = {};
        // tslint:disable-next-line:forin
        for (const p in data) {
            let cur = resultholder;
            let prop = '';
            let m;
            // tslint:disable-next-line:no-conditional-assignment
            while ((m = regex.exec(p))) {
                cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
                prop = m[2] || m[1];
            }
            cur[prop] = data[p];
        }
        return resultholder[''] || resultholder;
    };
}
